import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';

import {
  getCampaignBanner,
  getCampaignLogoUrl,
  getCampaignProfile,
  getCampaignBrandName,
  getCampaignBrandTitle,
  getCampaignBrandFontColor,
  getUseCampaignBanner,
  getUseCampaignLogo,
  getUseCampaignProfile
} from '../../redux/modules/campaignLandingPage';

import {
  StyledLogo,
  StyledProfileImage,
  StyledStackContainer,
  StyledStackProfileTitle,
  StyledStackTitle,
  StyledStackLogo
} from './styles';

const VpSplash = ({
  backgroundColor,
  logo,
  profile,
  name,
  title,
  color,
  useBanner,
  useLogo,
  useProfile
}) => {
  const [useProfileState, setUseProfile] = useState(!!useProfile);
  const [useLogoState, setUseLogo] = useState(!!useLogo);

  useEffect(() => {
    setUseProfile(useProfile);
    setUseLogo(useLogo);
  }, [useLogo, useProfile]);

  const src = logo || '';
  const profileSrc = profile || '';

  const styles = {
    ...(useBanner && backgroundColor ? { backgroundColor } : {})
  };

  return (
    <StyledStackContainer sx={styles}>
      <StyledStackLogo>
        {useLogoState && (
          <StyledLogo
            component="img"
            src={src}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              setUseLogo(false);
            }}
          />
        )}
      </StyledStackLogo>
      <StyledStackProfileTitle>
        <StyledStackTitle>
          {name && (
            <Typography variant="h6" sx={{ color }}>
              {name}
            </Typography>
          )}
          {title && <Typography sx={{ color }}>{title}</Typography>}
        </StyledStackTitle>
        {useProfileState && (
          <StyledProfileImage
            src={profileSrc}
            imageProps={{
              onError: ({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                setUseProfile(false);
              }
            }}
          />
        )}
      </StyledStackProfileTitle>
    </StyledStackContainer>
  );
};

VpSplash.propTypes = {
  backgroundColor: PropTypes.string,
  useBanner: PropTypes.bool,
  logo: PropTypes.string,
  useLogo: PropTypes.bool,
  profile: PropTypes.string,
  useProfile: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string
};

const mapStateToProps = (state) => ({
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  logo: getCampaignLogoUrl(state),
  useLogo: getUseCampaignLogo(state),
  profile: getCampaignProfile(state),
  useProfile: getUseCampaignProfile(state),
  name: getCampaignBrandName(state),
  title: getCampaignBrandTitle(state),
  color: getCampaignBrandFontColor(state)
});

export default connect(mapStateToProps)(VpSplash);



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/VpSplash.jsx